import React from 'react'
import {connect} from 'react-redux'
import Snackbar from 'material-ui/Snackbar'
import Spinner from 'react-spin'
import {login} from '../actions'

const NotifySnackbar =  React.createClass({
  displayName: 'NotifySnackbar',
  getInitialState() {
    return {
      message : '',
      autoHideDuration:3000,
      open : false,
      loading: false,
    }
  },
  componentWillReceiveProps(nextProps){
    let {event,message} = nextProps.notify
    let autoHideDuration,action
    switch(event){
      case 'loading':
      return this.setState({loading:true})

      case 'loaded':
      return this.setState({loading:false})

      case 'error':
      autoHideDuration = 0
      action = 'DISMISS'
      break

      case 'PERMISSION_DENIED':
      autoHideDuration = 0
      action = 'LOGIN'
      this.needReload = false
      break

      case 'reload':
      autoHideDuration = 0
      action = 'RELOAD'
      this.needReload = true
      break

      default:
      autoHideDuration = 2000
      break

    }

    this.setState({
      open:true,
      action:action,
      message:message,
      autoHideDuration:autoHideDuration,
    })
  },

  onActionTouchTap(){
    if(this.state.action ==='LOGIN'){
      this.props.dispatch(login())
      this.setState({ open: false})
    }

    if(this.state.action ==='RELOAD'){
      location.reload()
    }
    if(this.state.action ==='DISMISS'){
      this.setState({ open: false})
    }
  },
  onRequestClose(){
    if(this.needReload){
      window.setTimeout(()=>{
        this.setState({ open: true})
      },5000)
    }
    this.setState({ open: false})
  },
  renderSpinner(){
    if(!this.state.loading)
      return

    let style = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex:1200,
      backgroundColor: 'rgba(0,0,0,0.5)',
    }
    return (
      <div style={style}>
        <Spinner config={{color:'#FFF'}}/>
      </div>
      )
  },
  render() {
    let {action,message,open,autoHideDuration} = this.state
    return (
    <div>
      {this.renderSpinner()}
      {message &&<Snackbar
        open={open}
        action={action}
        message={message}
        autoHideDuration={autoHideDuration}
        onRequestClose={this.onRequestClose}
        onActionTouchTap={this.onActionTouchTap}/>
      }
    </div>
    )
  }
})

function mapStateToProps(state) {
  const { notify } = state
  return {
    notify
  }
}

export default connect(mapStateToProps)(NotifySnackbar)


/** WEBPACK FOOTER **
 ** ./src/app/components/NotifySnackbar.js
 **/